import React,{FC} from 'react';
import { MgpIconProps } from './MgpIcon.types';



export default function MgpIcon( {icon, color, size, ...props }: MgpIconProps) {
  let iconClassName = "icon-" + icon + (color? " " + color:"");
  
  return (
    <i className={iconClassName} {...props}/>
  );
}